import type { ReactNode } from "react";

/**
 * AccountGate — soft sign-up wall for the shared Tilt Report (#37).
 *
 * A share-link visitor sees the property, the Tilt Map, and the facts as a
 * teaser, but the deeper analysis (the AI brief, factor breakdown, flip watch,
 * cost-to-own) is blurred behind a "Create a free account" overlay. The gate is
 * intentionally SOFT — the content is still in the DOM, just visually locked —
 * so it reads as "there's more here" rather than a hard paywall. Logged-in
 * users (free or paid) pass straight through.
 */

interface Props {
  /** When true, blur the children and show the sign-up overlay. */
  locked: boolean;
  /** Kick off Cognito Managed Login (its chooser offers sign-up). */
  onSignIn: () => void;
  children: ReactNode;
}

export function AccountGate({ locked, onSignIn, children }: Props) {
  if (!locked) return <>{children}</>;

  return (
    <div className="account-gate">
      <div className="account-gate-content" aria-hidden>
        {children}
      </div>
      <div className="account-gate-overlay" role="note">
        <div className="account-gate-card">
          <h3>See the full Tilt Report</h3>
          <p>
            Create a free PriceTilt account to unlock the full AI analysis of
            this property — what the data shows, the factor breakdown, flip
            watch, and your monthly cost to own.
          </p>
          <button type="button" className="upgrade-cta" onClick={onSignIn}>
            Create a free account
          </button>
          <p className="account-gate-foot">
            Already have one? <button type="button" className="link-button" onClick={onSignIn}>Sign in</button>
          </p>
        </div>
      </div>
    </div>
  );
}
